import { Environment } from '../constants/environment';

export const getEnvironment = (): Environment => {
  const envName = process.env.REACT_APP_ENVIRONMENT || Environment.LOCAL;

  return Environment[envName.toUpperCase() as keyof typeof Environment] || Environment.LOCAL;
};
